module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020/0089.jpg?v=fff60c2c";